import { Component, h, Host, Prop } from '@stencil/core';

import { ClassNames } from '@/src/utils/interfaces';

@Component({
  tag: 'patternlib-pin',
  styleUrl: 'patternlib-pin.scss',
  shadow: true,
})
export class PatternlibHotspotButton {
  /**
   * Disable the pin.
   */
  @Prop({ reflect: true }) disabled = false;

  /**
   * Set size of pin.
   */
  @Prop() size: 'small' | 'medium' = 'medium';

  /**
   *  Set the type of the pin.
   */
  @Prop() type: 'default' | 'poi' = 'default';

  /**
   * Set the button into the active state programmatically.
   */
  @Prop() active = false;

  render() {
    /* #4295 introduces an outline for the pin using the CSS stroke property.
     * To accommodate the outline, the view box of the svg has been adjusted by 1px (stroke-width) in all directions
     */
    let pin;
    if (this.size === 'medium') {
      pin = (
        <span
          class="drop-shadow-[0_4px_4px_rgba(0,0,0,0.1)]"
          innerHTML={`
        <svg class="pin drop-shadow-pin" width="36" height="52" viewBox="-1 -1 38 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36 18.72C36 29.0588 20 52 18 52C16 52 0 29.0588 0 18.72C0 8.38123 8.05887 0 18 0C27.9411 0 36 8.38123 36 18.72Z" fill="" />
        </svg>`}
        ></span>
      );
    } else {
      pin = (
        <span
          class="drop-shadow-[0_4px_4px_rgba(0,0,0,0.1)]"
          innerHTML={`
        <svg class="pin drop-shadow-pin" width="24" height="35" viewBox="-1 -1 26 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M 24,12.6 C 24,19.558807 13.333333,35 12,35 10.666667,35 0,19.558807 0,12.6 0,5.6412125 5.37258,0 12,0 18.6274,0 24,5.6412125 24,12.6 Z" fill="" />
      </svg>
        `}
        ></span>
      );
    }

    const pinButtonClasses: ClassNames = {
      [this.type]: true,
      [this.size]: true,
      activeState: this.active,
    };

    return (
      <Host>
        <button class={pinButtonClasses} disabled={this.disabled}>
          <div class="flex justify-center">
            {pin}
            {this.type === 'default' ? (
              <div class="icon-wrapper">
                <slot />
              </div>
            ) : (
              <div class="poi"></div>
            )}
          </div>
        </button>
      </Host>
    );
  }
}
